import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ClearIcon from '@mui/icons-material/Clear';
import { ButtonBase, IconButton } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { useAppSelector } from '../../../../store/hooks';
import { OutputPromptLanguages, TranslatePromptLanguage } from '../../../../Helper';


interface LanguageModelProps {
  open: boolean;
  selectedLang: string;
  handleClose: () => void;
  setSelectedLang: (lan:string) => void;
  handleTranslate: () => void;
  languageModalType: string;
}

export const LanguageModel = ({
  open,
  handleClose,
  setSelectedLang,
  selectedLang,
  handleTranslate,
  languageModalType
}: LanguageModelProps) =>  {
  let languages = TranslatePromptLanguage;
  if (languageModalType === "Prompt")
    languages = OutputPromptLanguages;
  const User = useAppSelector((s) => s.User);
  
  const handleSelectLanguage = (lang:string) => {
    setSelectedLang(lang)
  }
  
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className="translate-prompt-modal" sx={{outline:'none'}}>
          <Box className="translate-modal-header">
            <Box className="translate-modal-header-titles">
                <Typography className='translate-modal-title'>{languageModalType === "Prompt" ? "Translate" : "Output language"}</Typography>
                <Typography className='translate-modal-description'>{languageModalType === "Prompt" ? "Convert your prompt to any language" : 
                "Choose the language of models response"}</Typography>
            </Box>
            <IconButton aria-label="fingerprint"  onClick={handleClose}>
                <ClearIcon sx={{color: User.darkMode ? '#fff' : '#0B1216'}}/>
            </IconButton>
          </Box>
          <Box className="translation-languages">
            {languages.map((lang,index) => (
              <Box key={index} className={`language-item ${selectedLang === lang && 'active'}`} onClick={() => handleSelectLanguage(lang)}>
                <Typography className="language-name">{lang}</Typography>
                {lang === "English" && <Typography className="default-language">Default</Typography>}
                {lang === selectedLang && <DoneIcon sx={{p:'0',marginLeft:'8px',width:'16px',height:'16px',color:'var(--m-font-color42)',}}/>}
              </Box>
            ))}
          </Box>
          <Box className="translate-modal-footer">
            <ButtonBase 
              sx={{
              p:'4px 24px',
              borderRadius:'10px',
              color:'var( --M-fontColor44)',
              fontSize:'16px',
              fontFamily:'Roboto',
              fontWeight:'500',
              border:'1px solid #12B6EA',
            }} 
              onClick={handleClose}>
                Cancel
              </ButtonBase>
            <ButtonBase  
              sx={{
              p:'4px 24px',
              borderRadius:'10px',
              color:'#fff',
              fontSize:'16px',
              fontFamily:'Roboto',
              fontWeight:'500',
              bgcolor:'#12B6EA',
              border:'1px solid transparent',
            }}
              onClick={languageModalType === "Prompt" ? handleTranslate : handleClose} 
              >
                Select
              </ButtonBase>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
